import { FinanceRate } from '@kanda-libs/ks-frontend-services';

export const calculateMonthlyPayment = (
  apr: number,
  terms: number,
  amount: number,
): number => {
  if (apr === 0) return Math.ceil(amount / terms);
  const monthlyInterest = apr / 12 / 10000; // r
  const compoundInterest = (1 + monthlyInterest) ** terms;
  const monthlyLoan =
    (amount * (monthlyInterest * compoundInterest)) / (compoundInterest - 1);
  return Math.ceil(monthlyLoan);
};

export const calculateMaxFromRate = (rate: FinanceRate): number => {
  const { duration = 10, apr = 0, max_job_value: maxJobValue = 500000 } = rate;
  return calculateMonthlyPayment(apr, duration, maxJobValue);
};

export const calculateMinFromRate = (rate: FinanceRate): number => {
  const { duration = 10, apr = 0, min_job_value: minJobValue = 100000 } = rate;
  return calculateMonthlyPayment(apr, duration, minJobValue);
};
